import { useEditor } from '../../state/editor';
import { useLibrary } from '../../state/library';
import { useT } from '../../i18n';

export function HistoryPanel() {
  const t = useT();
  const id = useLibrary((s) => s.activeId);
  const past = useEditor((s) => (id ? (s.history[id]?.past.length ?? 0) : 0));
  const future = useEditor((s) => (id ? (s.history[id]?.future.length ?? 0) : 0));
  return (
    <div style={{ display: 'flex', gap: 6, alignItems: 'center' }}>
      <button
        data-testid="undo"
        disabled={!id || past === 0}
        onClick={() => id && useEditor.getState().undo(id)}
        title="Ctrl+Z"
      >
        {t('undo')} ({past})
      </button>
      <button
        data-testid="redo"
        disabled={!id || future === 0}
        onClick={() => id && useEditor.getState().redo(id)}
        title="Ctrl+Shift+Z"
      >
        {t('redo')} ({future})
      </button>
    </div>
  );
}
